export const useProductPromos = () => {
  const authStore = useAuthStore()

  const userSegmentation = computed(() => {
    return authStore.user?.segments ?? []
  })

  return { userSegmentation }
}
